import React, { Component } from "react";
import NavControlsGenerator from "../utilities/NavControlsGenerator";

class VerificationTutorial extends Component {
  componentDidMount() {
  }
  render() {
    return (
      <section className="sectionContent"><div className="page">
        <header>
          <h2>Verification Tutorial</h2>
        </header>
        <div className="pageContent"></div>
        <NavControlsGenerator currentPageNavCode={95}></NavControlsGenerator>
      </div></section>
    );
  }
}

export default VerificationTutorial;
